import React from 'react';
import DeviceFrame from './DeviceFrame';

function SolutionSection() {
  return (
    <section className="block solution">
      <div className="wrap">
        <div className="sec-head">
          <h2>The Solution</h2>
          <div className="rule" />
        </div>

        <div className="split">
          <div className="copy">
            <div className="kicker">Personal by default</div>
            <h3>
              Every touchpoint is <span className="accent">personal</span>
            </h3>
            <p>
              Be different by showing you care. Every touchpoint is about the prospect — not your product.
              Share helpful, AI-surfaced relevant articles, timely insights, holiday cards, and meaningful
              notes that build trust.
            </p>
            <p>
              Effortless nurturing: once it&apos;s set up, the system works for you — drafting and sending on
              your behalf, always with your sign-off.
            </p>
          </div>
          <DeviceFrame
            src="assets/images/marketing/01-shot.png"
            alt="Nurturer Touches — an AI-drafted, article-backed email ready for the rep to review and send"
          />
        </div>

        <div className="split reverse">
          <DeviceFrame
            src="assets/images/marketing/02-shot.png"
            alt="Nurturer Dashboard — pipeline warmth, pending touchpoints, and reply rate at a glance"
          />
          <div className="copy">
            <div className="kicker">Right place, right time</div>
            <h3>
              Strike when the <span className="accent">timing&apos;s right</span>
            </h3>
            <p>
              Be seen as precise, not noise. Nurturer helps you identify the best moments to re-engage —
              making every ask feel natural, like following up after a trigger event or before a key
              decision window.
            </p>
            <p className="mini">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              No writing. Automatic scheduling. Just nurturing made easy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SolutionSection;
